export default __webpack_public_path__ + "static/media/Workshop_page1.7968cfa8.jpg";